export default __webpack_public_path__ + "static/media/ppt.b19589d5.png";